
import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { webUrlNode } from "../../../constants/appInfo";
import AdminBatchSections from "./AdminBatchSections";

  import { useRouteMatch,Switch, Route } from "react-router-dom";
  import { useHistory,} from "react-router-dom";
import BatchSubCourses from "./BatchSubCourses";
export default function BatchContents({
  
  
  onEdit
}) {

      const {url}=useRouteMatch();
   const history = useHistory();
 
    const {batchId} = useParams();
  const [batch, setBatch] = useState(null);
  const [loading, setLoading] = useState(false);
  const [contentDripArr, setContentDripArr] = useState([]);
        
        const courseData = useSelector((state)=>state?.course?.course);


  const AppToken = useSelector((s)=>s?.app?.app?.AppToken);
      const coursePostId = useSelector((state)=>state?.course?.course?.postId);
        const currentToken = useSelector((state)=>state?.user?.user?.token);
             const userEmail = useSelector((state)=>state?.user?.user?.user_email);
    
  useEffect(() => {
    if (!batchId ) return;
    load();loadDrip()
  }, [batchId]);

  async function load() {
    setLoading(true);
    try {
      const res = await axios.get(`${webUrlNode}/api/batches/${batchId}`, {
       params: {
         appToken:AppToken,
          coursePostId,
          userEmail,
          currentToken
          
        }
      });

      setBatch(res.data.item);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return <div style={{ padding: 12 }}>Loading batch…</div>;
  }

 
  async function loadDrip() {
    setLoading(true);
    try {
      const res = await axios.get(`${webUrlNode}/api/batches/${batchId}/content-manage`, {
       params: {
        appToken:AppToken,
          coursePostId,
          userEmail,
          currentToken
          
        }
      });

      setContentDripArr(res?.data?.items);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return <div style={{ padding: 12 }}>Loading batch…</div>;
  }

  if (!batch) return null;

  return (<div>
     <div  align="left" className=" " style={{background:"#ffffff",borderRadius:"25px",overflow:"hidden",border:"3px dotted rgba(144, 202, 249,1)",}}> 
        <div
        style={{
          display: "flex",padding:"10px",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 12
        }}
      >
        <div>

          <div style={{ fontSize: 28, fontWeight: 900 }}>
            {batch.batchName}  <span style={{ fontSize: 18, fontWeight: 900 }}>-Drip Settings</span>
          </div>

          <div style={{ fontSize: 16, color: "#666", marginTop: 4 }}>
            {batch.mode} • {batch.enrollmentStatus} • {batch.visibility}
          </div>

        </div>

       
      </div>
        <div
        style={{
          display: "grid",padding:"10px",background:"#f1f1f1",
          gridTemplateColumns: "repeat(auto-fit, minmax(140px,1fr))",
          gap: 12,
          marginTop: 14,
          fontSize: 13
        }}
      >
        <InfoItem
          label="Start"
          value={formatDate(batch.startDate)}
        />

        <InfoItem
          label="End"
          value={formatDate(batch.endDate)}
        />

        <InfoItem
          label="Timezone"
          value={batch.timezone || "—"}
        />

        <InfoItem
          label="Max students"
          value={batch.maxStudents ?? "—"}
        />

        <InfoItem
          label="Price"
          value={`₹ ${batch.price ?? 0}`}
        />

        <InfoItem
          label="Created"
          value={formatDate(batch?.createdAt)}
        />
      </div>
       <BatchSubCourses batch={batch} contentDripArr={contentDripArr} />
    

        
        </div>
     
    </div>
  );
}


/* ---------------- helpers ---------------- */

function InfoItem({ label, value }) {
  return (
    <div>
      <div style={{ color: "#777", fontSize: 11 }}>
        {label}
      </div>
      <div style={{ fontWeight: 500 }}>
        {value}
      </div>
    </div>
  );
}

function formatDate(v) {
  if (!v) return "—";
  return new Date(v).toLocaleString();
}


